import React, { useEffect, useState, useContext } from "react";
import { useParams } from "react-router-dom";
//  import profileImage from "profile.png";
import { FaPhoneAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useCallback } from "react";
import { useRef } from "react";
import { useUserContext } from "../context/DealerProfile.jsx";

import PaginatedList from './PaginationList.jsx';
import useSWR, { mutate } from "swr";

import { Mic, MicOff, ArrowLeft } from "lucide-react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import { AllStates } from "../context/globalState.jsx";
import { AllStates } from "../context/globalState.jsx";





const OrderDetail = ({ expanded }) => {

    // const [lead, setLead] = useState(null);
    const [emailError, setEmailError] = useState("");
    const [phoneError, setPhoneError] = useState("");
    const { dealerDetail } = useUserContext();
    const { allState, allStatedispatch } = useContext(AllStates);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedFields, setSelectedFields] = useState([]);
    const [selectedTransition, setSelectedTransition] = useState(null);
    const [modalData, setModalData] = useState(selectedTransition);
    const [isNotesModalOpen, setIsNotesModalOpen] = useState(false);

    const [textareaContent, setTextareaContent] = useState("");
    const [messageContent, setMessageContent] = useState("");
    const [notesContent, setNotesContent] = useState("");
    const [text, setText] = useState("");
    const [date, setDate] = useState("");
    const [datetime, setDatetime] = useState("");
    const [startDateTime, setStartDateTime] = useState("");
    const [endDateTime, setEndDateTime] = useState("");
    const [formData, setFormData] = useState("");
    const [optionss, setOptionss] = useState([]);
    const [picklistValues, setPicklistValues] = useState({});

    const [transitions, setTransitions] = useState([]);

    const { id } = useParams();


    const idToFetch = id;
    // const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const navigate = useNavigate();
    const [isWidgetModalOpen, setIsWidgetModalOpen] = useState(false);
    const fetcher = (url) => fetch(url).then((res) => res.json());

    const url = idToFetch ? `/server/dealer_backend/getSpecificRequest?id=${idToFetch}` : null;
    const { data, isLoading } = useSWR(url, fetcher, {
        revalidateOnFocus: false,      // don’t fetch when window regains focus
        revalidateOnReconnect: false,  // don’t fetch on network reconnect
        revalidateIfStale: false,      // don’t fetch if cached data is stale
    });

    // console.log({ data })

    useEffect(() => {
        // Revalidate when component mounts (page loads/comes into view)
        if (url) {
            mutate(url);
        }
    }, [url]);
    const lead = data?.status === "success" ? data.data[0] : null;
    const [alternatePhone, setAlternatePhone] = useState(lead?.Alternate_Mobile || "");
    const [callRemarks, setCallRemarks] = useState("");
    const [donorInterest, setDonorInterest] = useState("");
    const [callStatus, setCallStatus] = useState("");
    const [email, setEmail] = useState(lead?.Email || "");
    const [phone, setPhone] = useState(lead?.Mobile || "");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [alternatePhoneError, setAlternatePhoneError] = useState("");
    const [selectedRelatedList, setSelectedRelatedList] = useState(null);
    const [subDisposition, setSubDisposition] = useState("");




    const handleOpenModal = (transition) => {
        // console.log("Hi");
        setSelectedTransition(transition);  // Store selected transition
        setIsModalOpen(true);
    };















    const module = 'Indent_Request';

    const [relatedLists, setRelatedLists] = useState([]);



    const fetcher2 = (url) => fetch(url).then(res => res.json());

    const { data: data2 } = useSWR(
        module ? `/server/dealer_backend/getRelatedLists?module=${module}` : null,
        fetcher2,
        {
            revalidateOnFocus: false,      // don’t re-fetch when window/tab regains focus
            revalidateOnReconnect: false,  // don’t re-fetch when network reconnects
            revalidateIfStale: false,      // don’t auto revalidate if cached data is stale
        }
    );




    useEffect(() => {
        if (data2 && data2.status === "success") {
            setRelatedLists(data2.related_lists);
        }
    }, [data2]);










    const [picklistOptions, setPicklistOptions] = useState([]);

    const handleDownload = async (attachmentId) => {
        try {
            const response = await fetch(
                `/server/dealer_backend/downloadAttachments?module=${module}&recordId=${idToFetch}&attachmentId=${attachmentId}`
            );

            if (!response.ok) {
                throw new Error("Failed to fetch file");
            }

            // Extract filename from Content-Disposition header if available
            const disposition = response.headers.get("Content-Disposition");
            let fileName = `Attachment-${attachmentId}`;
            if (disposition && disposition.includes("filename=")) {
                const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(disposition);
                if (matches != null && matches[1]) {
                    fileName = matches[1].replace(/['"]/g, "");
                }
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);

            // Force file download
            const a = document.createElement("a");
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            a.remove();

            // Optional: cleanup the blob URL
            window.URL.revokeObjectURL(url);

        } catch (error) {
            // console.error("Download error:", error);
        }
    };





    const [picklistFieldId, setPicklistFieldId] = useState(""); // Store selected field ID



    const [notesData, setNotesData] = useState([]);
    const [statusData, setStatusData] = useState([]);
    const [attachments, setAttachments] = useState([]);
    const [emails, setEmails] = useState([]);
    const [payments, setPayments] = useState([]);
    const [calls, setCalls] = useState([]);
    const [rescheduleDateTime, setRescheduleDateTime] = useState("");
    const [donationPurpose, setDonationPurpose] = useState("");
    const [callDisposition, setCallDisposition] = useState("");

    const [isTransitionDisabled, setIsTransitionDisabled] = useState(false);



    const fetchNotes = async () => {
        try {
            const res = await fetch(`/server/dealer_backend/getNotes?module=${module}&recordId=${idToFetch}`);
            const json = await res.json();

            if (json.status === "success") {
                const sortedNotes = json.data.sort((a, b) => new Date(b.Created_Time) - new Date(a.Created_Time));
                setNotesData(sortedNotes);
            } else {
                // console.error("Error fetching notes:", json.error);
            }
        } catch (err) {
            // console.error("Network error:", err);
        }
    };



    const fetchAttachments = async () => {
        try {

            const res = await fetch(`/server/dealer_backend/getAttachments?module=${module}&recordId=${idToFetch}`);
            const json = await res.json();



            if (json.status === "success") {
                const sortedAttachments = json.data.sort((a, b) => new Date(b.Created_Time) - new Date(a.Created_Time));

                setAttachments(sortedAttachments);

            } else {
                // console.error("Error fetching attachments:", json.error);
            }
        } catch (err) {
            // console.error("Network error:", err);
        }
    };




    const fetchEmails = async () => {
        try {

            const res = await fetch(`/server/dealer_backend/getEmails?module=${module}&recordId=${idToFetch}`);
            const json = await res.json();

            // console.log(json)



            if (json.status === "success") {
                const sortedEmails = json.data.sort((a, b) => new Date(b.time) - new Date(a.time));
                setEmails(sortedEmails);

            } else {
                // console.error("Error fetching emails:", json.error);
            }
        } catch (err) {
            // console.error("Network error:", err);
        }
    };


    const fetchPayments = async () => {
        try {

            const res = await fetch(`/server/dealer_backend/getPayments?module=${module}&recordId=${idToFetch}`);
            const json = await res.json();

            // console.log(json)



            if (json.status === "success") {
                const sortedPayments = json.data.sort((a, b) => new Date(b.Created_Time) - new Date(a.Created_Time));

                setPayments(sortedPayments);

            } else {
                // console.error("Error fetching payments:", json.error);
            }
        } catch (err) {
            // console.error("Network error:", err);
        }
    };


    const fetchManualCalls = async () => {
        try {

            const res = await fetch(`/server/dealer_backend/getManualCalls?module=${module}&recordId=${idToFetch}`);
            const json = await res.json();

            //  console.log(json)



            if (json.status === "success") {
                const sortedCalls = json.data.sort((a, b) => new Date(b.Created_Time) - new Date(a.Created_Time));

                setCalls(sortedCalls);

            } else {
                // console.error("Error fetching payments:", json.error);
            }
        } catch (err) {
            // console.error("Network error:", err);
        }
    };

    useEffect(() => {
        fetchNotes();
        // fetchStatus();
        fetchAttachments();
        fetchEmails();
        fetchPayments();
        fetchManualCalls()

    }, [idToFetch])





    const formatSize = (bytes) => {
        if (!bytes) return "—";
        const kb = bytes / 1024;
        return kb < 1024
            ? `${kb.toFixed(1)} KB`
            : `${(kb / 1024).toFixed(2)} MB`;
    };









    const formatDateForBackend = (dateInput) => {
        if (!dateInput) return "";

        const date = new Date(dateInput);

        const pad = (n) => n.toString().padStart(2, "0");

        const year = date.getFullYear();
        const month = pad(date.getMonth() + 1);
        const day = pad(date.getDate());
        const hours = pad(date.getHours());
        const minutes = pad(date.getMinutes());
        const seconds = pad(date.getSeconds());

        const offset = -date.getTimezoneOffset(); // Note the sign flip
        const sign = offset >= 0 ? "+" : "-";
        const absOffset = Math.abs(offset);
        const offsetHours = pad(Math.floor(absOffset / 60));
        const offsetMinutes = pad(absOffset % 60);

        return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}${sign}${offsetHours}:${offsetMinutes}`;
    };


    // Format date for the input field (removes timezone offset)
    const formatDateForInput = (isoString) => {
        if (!isoString) return "";

        let date = new Date(isoString);
        return date.toISOString().slice(0, 16); // Keeps only YYYY-MM-DDTHH:MM
    };



  

    const handleEdit = () => {
        navigate("/edit-request/" + idToFetch);
    };


    const [remarksError, setRemarksError] = useState("");






    const fetchTransitions = async () => {
        try {
            const response = await fetch(`/server/dealer_backend/getTransitions?id=${idToFetch}`);
            const data = await response.json();
            console.log(data);

            if (data.status === "success") {
                setTransitions(data.transitions);
            } else {
                console.error("Failed to fetch transitions:", data.message);
            }
        } catch (error) {
            console.error("Error fetching transitions:", error);
        }
    };
    useEffect(() => {

        fetchTransitions();
    }, [idToFetch]);



    const handleSubmitTransition = async () => {


        if (!selectedTransition || !selectedTransition.fields) {
            console.warn("No transition or fields to process.");
            return;
        }
        const formData = selectedTransition.fields.reduce((acc, field) => {
            switch (field?.data_type) {
                case "textarea":
                    acc[field.api_name] = textareaContent;
                    break;
                case "message":
                    acc[field.api_name] = messageContent;
                    break;
                case "notes":
                    acc[field.display_label] = notesContent;
                    break;
                case "text":
                    acc[field.api_name] = text;
                    break;
                case "date":
                    acc[field.api_name] = date;
                    break;
                case "datetime":

                    acc[field.api_name] = field.api_name === "Start_DateTime" ? startDateTime : endDateTime;
                    break;
                case "picklist":
                    acc[field.api_name] = (picklistValues[field.api_name]?.display_value || picklistValues[field.api_name] || "");
                    break;

                default:
                    break;
            }
            return acc;
        }, {});

        // 🔁 Check if transition is "Contact in Future"
        const isContactInFuture = selectedTransition?.name === "Contacted in Future";
        const isfollowUp = selectedTransition?.name === "Take Follow Up";
        const isDemo = selectedTransition?.name === "Demo";
        const ismeeting = selectedTransition?.name == "Schedule Meeting";
        let transitionIdToUse = selectedTransition.id;

        console.log(selectedTransition?.name)
        // ✅ Conditionally build requestBody
        let requestBody;
        if (isContactInFuture || isfollowUp) {
            // 👉 For "Contacted in Future"
            requestBody = {
                blueprint: [
                    {
                        transition_id: transitionIdToUse,
                        data: {
                            Tasks: formData,
                            NPS_Rating123: "Others"
                        },
                    },
                ],
            };
        } else {
            // 👉 Default fallback
            requestBody = {
                data: [formData],
            };
        }

        // // ✅ Conditionally format the body
        // const requestBody = isContactInFuture
        //   ? {
        //       blueprint: [
        //         {
        //           transition_id: transitionIdToUse,
        //           data: {
        //             Tasks: formData, // wrap all fields in Tasks
        //           },
        //         },
        //       ],
        //     }
        //   : {
        //       data: [formData], // standard case
        //     };

        // formData.transition_id = selectedTransition.id;

        try {
            const response = await fetch(`/server/dealer_backend/update-blueprint?id=${idToFetch}&transition_id=${selectedTransition.id}&module=${module}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestBody),
            });

            const result = await response.json();
            // console.log("Response from backend:", result);

            if (result.status === "success") {
                toast.success("Ticket updated successfully!");

                // Close the modal
                setIsModalOpen(false) // Ensure you have this state defined in your component

                // if (selectedTransition.name === "Interested") {
                //   navigate("/leadToDeal"); // Redirect to restricted page
                // }

                // Reload the page
                // window.location.reload();
                await fetchTransitions(); // ✅ Refresh transitions
                // await fetchLeadData();

                // await fetchCLosed

            } else {
                toast.error("Failed to update lead.");
            }
        } catch (error) {
            toast.error("Error submitting form:", error);
        }

    };







    const LeadField = ({ label, value, icon }) => (
        <div className="form-group-field2">
            <label>{label}</label>
            <span>
                {icon && <span className="icon">{icon}</span>}
                {value || "—"}
            </span>
        </div>
    );






    const formatDate = (isoString) => {
        const date = new Date(isoString);
        return date.toLocaleString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        });
    };


    const vari = `${lead?.Name || ''}`.trim();




    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(5);

    const totalPages = Math.ceil(calls.length / recordsPerPage);

    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;



    // const [callRemarks, setCallRemarks] = useState("");




    useEffect(() => {
        if (
            isModalOpen &&
            selectedTransition &&
            selectedTransition.fields.length === 0
        ) {
            handleSubmitTransition();
        }
    }, [isModalOpen, selectedTransition]);

    const [formValues, setFormValues] = useState({});




    // Function to render only specific input fields
    const renderInputField = (field) => {
        switch (field?.data_type) {
            case "textarea":
                return (
                    <textarea
                        name="textareaContent"
                        value={textareaContent}
                        onChange={(e) => setTextareaContent(e.target.value)}
                        placeholder="Enter content"
                        className="w-full border border-red-300 rounded-md px-3 py-2 mt-1 focus:outline-none focus:ring-1 focus:ring-blue-500 resize-none"
                        rows="4"
                        cols="50"
                    />
                );

            case "notes":
                return (
                    <textarea
                        name="notesContent"
                        value={notesContent}
                        onChange={(e) => setNotesContent(e.target.value)}
                        className="w-full border border-red-500 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        placeholder="Enter notes"
                        rows="4"
                        cols="50"
                    />
                );

            case "text":
                return (
                    <input
                        type="text"
                        name="text"
                        value={text}
                        onChange={(e) => setText(e.target.value)}
                        className={`w-full border rounded-md px-3 py-2 mt-1 focus:outline-none focus:ring-1 ${field.display_label === "Subject"
                            ? "border-red-500 focus:ring-blue-500"
                            : "border-gray-300 focus:ring-blue-500"
                            }`}
                        placeholder={
                            field.display_label === "Subject" ? "Enter subject" : "Enter text"
                        }
                    />
                );


            case "date":
                return (
                    <input
                        type="date"
                        name="date"
                        value={date}
                        className="w-full border border-gray-300 rounded-md px-3 py-2 mt-1 focus:outline-none focus:ring-1 focus:ring-blue-500"
                        onChange={(e) => setDate(e.target.value)}
                    />
                );

            case "datetime":
                return (
                    <input
                        type="datetime-local"
                        name={field.api_name}
                        value={
                            formData[field.api_name]
                                ? formatDateForInput(formData[field.api_name])
                                : ""
                        }
                        className="w-full border border-gray-300 rounded-md px-3 py-2 mt-1 focus:outline-none focus:ring-1 focus:ring-blue-500"
                        onChange={(e) => {
                            const formattedDate = formatDateForBackend(e.target.value);
                            console.log(formattedDate)
                            setEndDateTime(formattedDate);
                            setFormData((prev) => ({
                                ...prev,
                                [field.api_name]: formattedDate,
                            }));
                        }}
                    />
                );
            case "picklist":
                return (
                    <select
                        name={field.api_name}
                        value={picklistValues[field.api_name]?.id || ""} // Store ID, not just display_value
                        className="w-full border border-gray-300 rounded-md px-3 py-2 mt-1 focus:outline-none focus:ring-1 focus:ring-blue-500"
                        onChange={(e) => {
                            const selectedOption = field.pick_list_values.find(
                                (option) => option.id === e.target.value
                            );
                            setPicklistValues((prev) => ({
                                ...prev,
                                [field.api_name]: selectedOption || {}, // Store full selected option
                            }));
                        }}
                    >
                        {field.pick_list_values.length > 0 ? (
                            field.pick_list_values.map((option) => (
                                <option key={option.id} value={option.id}> {/* Pass ID in value */}
                                    {option.display_value}
                                </option>
                            ))
                        ) : (
                            <option disabled>Loading...</option>
                        )}
                    </select>
                );

            case "multiselectpicklist":
                return (
                    <select
                        name={field.api_name}
                        value={picklistValues[field.api_name]?.id || ""} // Store ID, not just display_value
                        className="w-full border border-gray-300 rounded-md px-3 py-2 mt-1 focus:outline-none focus:ring-1 focus:ring-blue-500"
                        onChange={(e) => {
                            const selectedOption = field.pick_list_values.find(
                                (option) => option.id === e.target.value
                            );
                            setPicklistValues((prev) => ({
                                ...prev,
                                [field.api_name]: selectedOption || {}, // Store full selected option
                            }));
                        }}
                    >
                        {field.pick_list_values.length > 0 ? (
                            field.pick_list_values.map((option) => (
                                <option key={option.id} value={option.id}> {/* Pass ID in value */}
                                    {option.display_value}
                                </option>
                            ))
                        ) : (
                            <option disabled>Loading...</option>
                        )}
                    </select>
                );

            default:
                return null;
        }
    };


    const handleTransitionClick = (transition) => {
        // Current state check
        // console.log({transition});
        if (

            transition.name === "Onboarded"
        ) {
            navigate("/lead-convert"); // 👈 navigate here
            return;
        }

        // default behavior
        handleOpenModal(transition);
    };


    useEffect(() => {
        if (!selectedTransition) return;

        const initialValues = {};

        selectedTransition.fields.forEach((field) => {
            if (field.content) {
                // PICKLIST
                if (field.data_type === "picklist") {
                    const selectedOption = field.pick_list_values.find(
                        (opt) => opt.display_value === field.content
                    );
                    if (selectedOption) {
                        initialValues[field.api_name] = selectedOption.id;
                    }
                }

                // LOOKUP
                else if (field.data_type === "lookup") {
                    initialValues[field.api_name] = field.content.id;
                }

                // DATE
                else if (field.data_type === "date") {
                    initialValues[field.api_name] = field.content;
                }

                // TEXT / TEXTAREA
                else {
                    initialValues[field.api_name] = field.content;
                }
            }
        });

        setFormValues(initialValues);
    }, [selectedTransition]);




    // console.log({selectedTransition})




    return isLoading ? (
        <div className="flex justify-center items-center h-screen">
            <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-blue-500"></div>
        </div>
    ) : (
        <React.Fragment>
            <ToastContainer position="top-right" autoClose={3000} />
            <header style={{
                position: 'fixed',
                top: 0,
                left: expanded ? '5rem' : '16rem',
                right: 0,
                height: '5rem',
                backgroundColor: 'white',
                zIndex: 1000,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '1rem',
                borderBottom: '1px solid #e5e7eb',
            }} className="header-fixed mobile-header bg-white h-screen overflow-auto border-b px-6 py-4 flex items-center justify-between">
                <div className="flex items-center space-x-4">
                    {/* <button className="text-gray-600 hover:text-black text-lg">←</button> */}
                    <button
                        className="text-gray-600 hover:text-black text-lg"
                        onClick={() => navigate('/indent-request')}  // Go back one step in browser history
                        aria-label="Go back"
                    >
                        <ArrowLeft />
                    </button>


                    <div className="header-icon w-10 h-10 rounded-full bg-[#2070B9] flex items-center justify-center text-white font-semibold text-lg ">
                        {vari.charAt(0).toUpperCase()}
                    </div>


                    <h1 className="text-xl font-semibold hidden sm:block">
                        {`${lead?.Name || ''}`.trim()}
                    </h1>


                    {/* <button
                        type="button"
                        className="px-4 py-1.5 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 transition"
                        onClick={handleEdit}
                    >
                        Edit
                    </button> */}


                </div>










            </header>
            <div className="flex " style={{ display: 'flex', marginTop: '4rem', height: 'calc(100vh - 4rem)' }}>
                {/* Sidebar */}
                <aside style={{
                    position: 'fixed',
                    top: '4rem',
                    left: expanded ? '16rem' : '16rem',
                    bottom: 0,
                    backgroundColor: 'white',
                    padding: '1rem',
                    borderRight: '1px solid #e5e7eb',
                    overflowY: 'auto',
                }} className="related-list header-fixed w-64 bg-white border-r p-4 min-h-screen">
                    <h3 className="text-lg font-semibold mb-4">Related List</h3>
                    <ul className="space-y-2 text-sm text-gray-700">
                        {relatedLists.map((item, idx) => (
                            <li
                                key={item.id || idx}
                                onClick={() => {
                                    setSelectedRelatedList(item.name);
                                    if (item.name === "Notes") {
                                        window.location.hash = "#notes";
                                    } else if (item.name === "Lead Status History") {
                                        window.location.hash = "#status";
                                    } else if (item.name === "Attachments") {
                                        window.location.hash = "#attach";
                                    } else if (item.name === "Emails") {
                                        window.location.hash = "#email";
                                    } else if (item.name === "Manual Call") {
                                        window.location.hash = "#call";
                                    } else if (item.name === "Payments") {
                                        window.location.hash = "#payment";
                                    }
                                }}
                                className={`flex justify-between items-center hover:bg-gray-100 px-2 py-1 rounded cursor-pointer ${selectedRelatedList === item.name ? "bg-gray-100 font-medium" : ""
                                    }`}
                            >
                                <span className="flex items-center gap-1">
                                    {item.display_label || item.name}

                                    {/* Count badges */}
                                    {item.name === "Notes" && notesData.length > 0 && (
                                        <span className="ml-1 text-xs bg-gray-200 text-gray-800 rounded-full px-2 py-0.5">
                                            {notesData.length}
                                        </span>
                                    )}
                                    {item.name === "Attachments" && attachments.length > 0 && (
                                        <span className="ml-1 text-xs bg-gray-200 text-gray-800 rounded-full px-2 py-0.5">
                                            {attachments.length}
                                        </span>
                                    )}
                                    {item.name === "Emails" && emails.length > 0 && (
                                        <span className="ml-1 text-xs bg-gray-200 text-gray-800 rounded-full px-2 py-0.5">
                                            {emails.length}
                                        </span>
                                    )}
                                    {item.name === "Manual Call" && calls.length > 0 && (
                                        <span className="ml-1 text-xs bg-gray-200 text-gray-800 rounded-full px-2 py-0.5">
                                            {calls.length}
                                        </span>
                                    )}
                                    {item.name === "Payments" && payments.length > 0 && (
                                        <span className="ml-1 text-xs bg-gray-200 text-gray-800 rounded-full px-2 py-0.5">
                                            {payments.length}
                                        </span>
                                    )}
                                    {item.name === "Lead Status History" && statusData.length > 0 && (
                                        <span className="ml-1 text-xs bg-gray-200 text-gray-800 rounded-full px-2 py-0.5">
                                            {statusData.length}
                                        </span>
                                    )}
                                </span>
                            </li>
                        ))}
                    </ul>
                </aside>



                {/* Main Content */}
                <main style={{
                    // marginTop: '4rem',
                    // marginLeft: '14rem',
                    // height: 'calc(100vh - 4rem)',
                    // overflowY: 'auto',
                    padding: '1rem',
                    flexGrow: 1,
                }}>
                    <div className="lead-maindiv lead-container p-4 flex-1">

                        {/* Modal for Widget */}






                        {/* Lead Status Card */}
                        {/* <div className="card lead-status-card">
                            <div className="card-header">
                                <h3><span className="lead-headings">Current State</span> <span>{lead?.Ticket_Stages}</span></h3>
                            </div>



                            <div className="lead-actions">
                                {lead?.Lead_Status !== "Interested" && (
                                    <>
                                        <span className="lead-headings">Transition</span>
                                        <div className="lead-actions-button">
                                            {transitions.map((transition) => (
                                                <button key={transition.id} className="action-btn" onClick={() => handleTransitionClick(transition)}
                                                >
                                                    {transition.name}
                                                </button>
                                            ))}
                                        </div>
                                    </>
                                )}
                            </div>
                        </div> */}

                        {/* Lead Information */}
                        <div className="lead-profile-container">
                            {lead ? (
                                <div className="lead-cards">
                                    <div className="lead-card">
                                        {/* <div className="form-group-field"><label>Potential Donor Owner</label><span>{lead.Owner || "—"}</span></div> */}
                                        {/* <div className="form-group-field"><label>Potential Donor Source</label><span>{lead.Lead_Source || "—"}</span></div> */}
                                        <div className="form-group-field"><label>Ticket</label><span >{lead?.Ticket || "—"}</span></div>
                                        <div className="form-group-field"><label>Part Code</label><span >{lead?.Part_Code || "—"}</span></div>
                                        <div className="form-group-field"><label>Replacement Type</label><span>{lead?.Replacement_Type || "—"}</span></div>
                                        <div className="form-group-field">
                                            <label>Indent Stages</label>
                                            <span
                                                className={`
    inline-block w-fit
    text-xs font-semibold px-2 py-1 rounded-[12px]
    ${lead?.Indent_Stages === "Contacted"
                                                        ? "bg-green-300 text-white"
                                                        : lead?.Indent_Stages === "Work Completed"
                                                            ? "bg-green-500 text-black"
                                                            : lead?.Indent_Stages === "Cancel"
                                                                ? "bg-pink-400 text-white"
                                                                : lead?.Indent_Stages === "Not Interested"
                                                                    ? "bg-red-400 text-white"
                                                                    : lead?.Indent_Stages === "RNR"
                                                                        ? "bg-wheat-500 text-white"
                                                                        : lead?.Indent_Stages === "Convert to Donor"
                                                                            ? "bg-gray-500 text-white"
                                                                            : "bg-yellow-300 text-black"}
  `}
                                            >
                                                {lead?.Indent_Stages || "—"}
                                            </span>

                                        </div>
                                        {/* <div className="form-group-field"><label>Customer Remark</label><span>{lead?.Ticket_Name || "—"}</span></div> */}

                                    </div>
                                </div>
                            ) : (
                                <p className="loading-text">Loading ticket details...</p>
                            )}
                        </div>

                        {/* Donor Info Section */}
                        <div className="lead-container2">
                            <h3 className="lead-title">Indent Request Information</h3>
                            <hr className="lead-divider" />

                            {lead && (
                                <div className="table-mobile grid grid-cols-1 md:grid-cols-2 gap-6 text-sm text-gray-700 break-words">

                                    {/* Left Column */}
                                    <div className="space-y-3">
                                        <LeadField label="Call ID" value={lead?.Call_ID} />
                                        <LeadField label="Part Code" value={lead?.Part_Code} />
                                        <LeadField label="Part Warranty Status" value={lead?.Part_Warranty_Status} />
                                        <LeadField label="Pending Part Status" value={lead?.Pending_Part_Status || "—"} />
                                        <LeadField label="Requested Date Time" value={lead?.Requested_Date_Time || "—"} />
                                        <LeadField label="Indent Stage" value={lead?.Indent_Stages} />
                                        <LeadField label="Defect Code" value={lead?.Defect_Code} />
                                        <LeadField label="Technician Email" value={lead?.Technician_Email} />
                                        <LeadField label="OC Number" value={lead?.OC_Number || "—"} />
                                        <LeadField label="RMA Generation" value={lead?.RMA_Generation || "—"} />
                                    </div>

                                    {/* Right Column */}
                                    <div className="space-y-3">
                                        {/* <LeadField label="Indent Request Owner" value={lead?.indentRequestOwner} /> */}
                                        <LeadField label="Part Description" value={lead?.Part_No || "—"} />
                                        <LeadField label="Indent Request Name" value={lead?.Name} />
                                        <LeadField label="Consumed Quantity" value={lead?.Consumed_Quantity} />
                                        <LeadField label="Part Source" value={lead?.Part_Source} />
                                        <LeadField label="Returnable Flag" value={lead?.Returnable_Flag} />
                                        <LeadField label="Replacement Type" value={lead?.Replacement_Type} />
                                        <LeadField label="Date Of Purchase" value={lead?.Date_Of_Purchase || "—"} />
                                        <LeadField label="Symptom Code" value={lead?.Symptom_Code} />
                                        <LeadField label="Warehouse" value={lead?.Warehouse || "—"} />
                                    </div>

                                </div>
                            )}
                        </div>


                        <div className="lead-container2">
                            <h3 className="lead-title">Call Information</h3>
                            <hr className="lead-divider" />

                            {lead && (
                                <div className="table-mobile grid grid-cols-1 md:grid-cols-2 gap-6 text-sm text-gray-700 break-words">

                                    {/* Left Column */}
                                    <div className="space-y-3">
                                        <LeadField label="Ticket" value={lead?.Ticket} />
                                        <LeadField label="Customer Remark" value={lead?.Customer_Remark} />
                                        {/* <LeadField label="Call Type" value={lead?.Call_Type} />
                                        <LeadField label="Types of Call" value={lead?.Types_of_Call} /> */}
                                    </div>

                                    {/* Right Column */}
                                    <div className="space-y-3">
                                        <LeadField label="Customer" value={lead?.Customer} />

                                     

                                        {/* <LeadField label="ASP User" value={lead?.ASP_User} /> */}
                                        {/* <LeadField label="Ticket Owner" value={lead?.Ticket_Owner} /> */}
                                    </div>

                                </div>
                            )}
                        </div>




                        {/* Address Info Section */}






                        {lead?.IFR_Lead_Sources === "Face to Face" && (
                            <div className="lead-container2">
                                <h3 className="lead-title">Face to Face Information</h3>
                                <hr className="lead-divider" />
                                {lead && (
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-sm text-gray-700">
                                        <div className="space-y-3">
                                            <LeadField label="Donation Purpose" value={lead?.Purpose1} />
                                            <LeadField label="Meeting Location" value={lead?.Meeting_Location} />
                                            <LeadField label="Region" value={lead?.Region} />
                                        </div>
                                        <div className="space-y-3">
                                            <LeadField label="ID Proof Type" value={lead?.ID_Proof_Type} />
                                            <LeadField label="ID Proof Number" value={lead?.ID_Proof_Number} />
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}



                        <div id="notes" className="lead-container2">
                            <h3 className="text-lg font-semibold mb-3">Notes</h3>

                            {notesData.length > 0 && (
                                <PaginatedList data={notesData}>
                                    {({
                                        data,
                                        currentPage,
                                        totalPages,
                                        totalRecords,
                                        startEntry,
                                        endEntry,
                                        recordsPerPage,
                                        handleChangePage,
                                        handlePageSizeChange,
                                    }) => (
                                        <>
                                            {/* Table */}
                                            <div className="overflow-x-auto">
                                                <table className="min-w-full text-sm border-collapse">
                                                    <thead>
                                                        <tr className="border-b bg-gray-50 text-left">
                                                            <th className="py-2 px-3">Note</th>
                                                            <th className="py-2 px-3">Potential Donor</th>
                                                            <th className="py-2 px-3">Time</th>
                                                            {/* <th className="py-2 px-3">Owner</th> */}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {data.map((note, idx) => (
                                                            <tr key={idx} className="border-t">
                                                                <td className="py-2 px-3">{note.Note_Content || "—"}</td>
                                                                <td className="py-2 px-3">{note.Parent_Id?.name || "—"}</td>
                                                                <td className="py-2 px-3">now</td>
                                                                {/* <td className="py-2 px-3">{note.Owner?.name || "—"}</td> */}
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>

                                            {/* Pagination controls */}
                                            <div className="mt-4 flex flex-col md:flex-row justify-between items-start md:items-center gap-2 text-sm">
                                                {/* Entry range info */}
                                                <div>
                                                    Showing {startEntry} to {endEntry} of {totalRecords} Entries
                                                </div>

                                                {/* Page size selector */}
                                                <div className="flex items-center gap-2">
                                                    <label htmlFor="notesPageSize">Records per list:</label>
                                                    <select
                                                        id="notesPageSize"
                                                        value={recordsPerPage}
                                                        onChange={handlePageSizeChange}
                                                        className="border px-2 py-1 rounded"
                                                    >
                                                        <option value={5}>5</option>
                                                        <option value={10}>10</option>
                                                        <option value={25}>25</option>
                                                    </select>
                                                </div>

                                                {/* Pagination buttons */}
                                                <div className="flex items-center gap-2">
                                                    <button
                                                        onClick={() => handleChangePage(currentPage - 1)}
                                                        disabled={currentPage === 1}
                                                        className="px-3 py-1 border rounded disabled:opacity-50"
                                                    >
                                                        Prev
                                                    </button>
                                                    <button
                                                        onClick={() => handleChangePage(currentPage + 1)}
                                                        disabled={currentPage === totalPages}
                                                        className="px-3 py-1 border rounded disabled:opacity-50"
                                                    >
                                                        Next
                                                    </button>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </PaginatedList>)}
                        </div>












                        <div id="attach" className="lead-container2">
                            <h3 className="text-lg font-semibold mb-3">Attachments</h3>

                            {attachments.length > 0 && (
                                <PaginatedList data={attachments}>
                                    {({
                                        data,
                                        currentPage,
                                        totalPages,
                                        totalRecords,
                                        startEntry,
                                        endEntry,
                                        recordsPerPage,
                                        handleChangePage,
                                        handlePageSizeChange,
                                    }) => (
                                        <>
                                            <div className="overflow-x-auto">
                                                <table className="min-w-full text-sm border-collapse">
                                                    <thead>
                                                        <tr className="border-b bg-gray-50 text-left">
                                                            <th className="py-2 px-3">File Name</th>
                                                            {/* <th className="py-2 px-3">Attached By</th> */}
                                                            <th className="py-2 px-3">Date Added</th>
                                                            <th className="py-2 px-3">Size</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {data.map((att, idx) => (
                                                            <tr key={idx} className="border-t">
                                                                <td className="py-2 px-3">
                                                                    {att.File_Name ? (
                                                                        <a
                                                                            href="#"
                                                                            className="text-blue-600 underline cursor-pointer"
                                                                            onClick={(e) => {
                                                                                e.preventDefault();
                                                                                handleDownload(att.id);
                                                                            }}
                                                                        >
                                                                            {att.File_Name}
                                                                        </a>
                                                                    ) : "—"}
                                                                </td>
                                                                {/* <td className="py-2 px-3">{att.Owner?.name || "—"}</td> */}
                                                                <td className="py-2 px-3">{att.Created_Time ? formatDate(att.Created_Time) : "—"}</td>
                                                                <td className="py-2 px-3">{formatSize(att.Size)}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>

                                            <div className="mt-4 flex flex-col md:flex-row justify-between items-start md:items-center gap-2 text-sm">
                                                <div>Showing {startEntry} to {endEntry} of {totalRecords} Entries</div>

                                                <div className="flex items-center gap-2">
                                                    <label htmlFor="attachPageSize">Records per list:</label>
                                                    <select
                                                        id="attachPageSize"
                                                        value={recordsPerPage}
                                                        onChange={handlePageSizeChange}
                                                        className="border px-2 py-1 rounded"
                                                    >
                                                        <option value={5}>5</option>
                                                        <option value={10}>10</option>
                                                        <option value={25}>25</option>
                                                    </select>
                                                </div>

                                                <div className="flex items-center gap-2">
                                                    <button
                                                        onClick={() => handleChangePage(currentPage - 1)}
                                                        disabled={currentPage === 1}
                                                        className="px-3 py-1 border rounded disabled:opacity-50"
                                                    >
                                                        Prev
                                                    </button>

                                                    <button
                                                        onClick={() => handleChangePage(currentPage + 1)}
                                                        disabled={currentPage === totalPages}
                                                        className="px-3 py-1 border rounded disabled:opacity-50"
                                                    >
                                                        Next
                                                    </button>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </PaginatedList>
                            )}
                        </div>







                        {/* {showModal && (
              <SendMailModal
                idToFetch={lead?.id}
                lead={lead}
                firstName={lead?.First_Name}
                lastName={lead?.Last_Name}
                onEmailSent={fetchEmails} // ✅ pass function here
                onClose={() => setShowModal(false)}
              />
            )} */}




                        {isModalOpen && selectedTransition && (
                            selectedTransition.fields.length > 0 && (
                                <div className="modal-overlay">
                                    <div className="modal-content">
                                        <h2>{selectedTransition.next_field_value}</h2>

                                        <div className="transitions">
                                            {selectedTransition.fields.map((field, idx) => (
                                                <div key={idx} className="modal-field">
                                                    {field.display_label !== "message" && (
                                                        <label>{field.display_label}</label>
                                                    )}
                                                    {renderInputField(field)}
                                                </div>
                                            ))}
                                        </div>

                                        <div className="space-x-2">
                                            <button
                                                className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700"
                                                onClick={handleSubmitTransition}
                                            >
                                                Submit
                                            </button>
                                            <button
                                                className="mr-2 px-4 py-2 border rounded-md text-gray-600 hover:bg-gray-100"
                                                onClick={() => setIsModalOpen(false)}
                                            >
                                                Close
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )
                        )}










                    </div>
                </main>
            </div>
        </React.Fragment>
    );
};





export default OrderDetail;
